import { Button } from '@change/ds-core-ui/Button';

import { Translate } from '@change-corgi/core-react/i18n';

import { useClearLocationFilter } from './hooks/useClearLocationFilter';

export const ClearLocationFilter: React.FC = () => {
	const {
		data: { hideButton },
		actions: { clearRefine },
	} = useClearLocationFilter();

	if (hideButton) return null;

	return (
		<Button variant="secondary" onClick={clearRefine} size="small" className="w-full md:w-auto">
			<Translate value="corgi.search.filters.clear_filters.clear" />
		</Button>
	);
};
